module.exports = __webpack_public_path__ + "static/media/dataApp.fef45d96.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/images/dataApp.png
// module id = 425
// module chunks = 9